import React from 'react';

import { UserForm } from './UserForm';
import { FormModal } from '../common/form/FormModal';
import { ActionButton } from '../common/buttons/ActionButton';
import { ConfirmationActionButton } from '../common/buttons/ConfirmationActionButton';

import { remove as removeUser, update as updateUser } from '../../apis/users';
import { useModal } from '../../hooks/useModal';

export const UsersListItem = ({ onRefresh, ...row }) => {
    const {
        showModal: showViewModal,
        handleShow: handleViewShow,
        handleHide: handleViewHide
    } = useModal();
    const {
        showModal: showEditModal,
        handleShow: handleEditShow,
        handleHide: handleEditHide
    } = useModal();

    const UserFormModal = (props) => {
        return (
            <FormModal
                notificationTitle="Users"
                notificationIcon="icons"
                onSucceed={onRefresh}
                form={UserForm}
                {...props}
            />
        );
    };

    const ViewActionButton = (props) => {
        return <ActionButton onClick={handleViewShow} tooltipText="View" {...props} />;
    };

    const EditActionButton = (props) => {
        return <ActionButton onClick={handleEditShow} tooltipText="Edit" {...props} />;
    };

    const RemoveActionButton = (props) => {
        return (
            <ConfirmationActionButton
                confirmationText={`Do you want to remove "${row.name}" user?`}
                notificationTitle="Users"
                notificationIcon="user"
                tooltipText="Remove"
                action={() => removeUser(row.id)}
                onSucceed={onRefresh}
                {...props}
            />
        );
    };

    return (
        <li className="list-group-item">
            <div className="row">
                <div className="name-cell col-lg-3 col-xl-4 d-flex justify-content-between">
                    <label className="d-block d-lg-none fw-bold my-2">Name</label>
                    <p className="text-dark my-2">{row.name}</p>
                </div>
                <div className="email-cell col-lg-4 col-xl-4 d-flex justify-content-between">
                    <label className="d-block d-lg-none fw-bold my-2">Email</label>
                    <p className="text-dark my-2">{row.email}</p>
                </div>
                <div className="role-cell col-lg-2 col-xl-2 d-flex justify-content-between">
                    <label className="d-block d-lg-none fw-bold my-2">Role</label>
                    <p className="text-dark my-2">{row.role}</p>
                </div>
                <div className="actions-cell col-lg-3 col-xl-2 d-flex justify-content-between">
                    <label className="d-block d-lg-none fw-bold my-2">Actions</label>
                    <p className="text-end text-lg-center w-100 my-1">
                        <ViewActionButton className="btn btn-sm btn-outline-primary ms-2">
                            <span className="far fa-eye fa-fw"></span>
                        </ViewActionButton>
                        <EditActionButton className="btn btn-sm btn-outline-primary ms-2">
                            <span className="far fa-edit fa-fw"></span>
                        </EditActionButton>
                        <RemoveActionButton className="btn btn-sm btn-outline-primary ms-2">
                            <span className="far fa-trash fa-fw"></span>
                        </RemoveActionButton>
                    </p>
                </div>
                <div className="modal-wrappers">
                    <UserFormModal
                        model={row}
                        mode="show"
                        title="View user"
                        show={showViewModal}
                        onHide={handleViewHide}
                    />
                    <UserFormModal
                        model={row}
                        mode="edit"
                        title="Edit user"
                        action={updateUser}
                        show={showEditModal}
                        onHide={handleEditHide}
                    />
                </div>
            </div>
        </li>
    );
};
